import { createStore } from 'vuex'

import dashboard from './dashboard'
import i18n from './i18n'
import search from './search'

export default createStore({
	modules: {
		dashboard,
		i18n,
		search,
	},
})
